"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultSessionManager = void 0;
exports.getDefaultSessionManager = {
    getSiteMemberId: function () {
        return '';
    },
    getVisitorId: function () {
        return '';
    },
    addLoadNewSessionCallback: function (callback) {
        return function () {
            callback({
                results: {
                    instances: {
                        '': '',
                    },
                },
                reason: 'noSpecificReason',
            });
        };
    },
};
//# sourceMappingURL=utils.js.map